import { ApiError } from "@/api/rest/core/types";

// PostHog captures console.error as an exception. A rejected login is an
// expected outcome the user already sees on the form, so it stays out.
export const logLoginFailure = (error: unknown) => {
  if (error instanceof ApiError) {
    console.log(error);
    return;
  }
  console.error(error);
};
